<template>
  <el-dialog @close="dialogClose"
             :visible.sync="visible"
             class="simulate-dialog-container"
             title="模拟生成规则">
    <el-form :model="simulateForm"
             ref="simulateForm"
             :rules="formRules"
             label-width="100px">
      <el-row>
        <el-col :span="20">
          <el-form-item label="编码规则"
                        prop="rule_name">
            <el-input v-model="simulateForm.rule_name"
                      disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="申请数量"
                        prop="apply_num">
            <el-input v-model="simulateForm.apply_num">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="vo对象"
                        prop="sources_data_value">
            <el-input v-model="simulateForm.sources_data_value">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col class="simulate-res"
                :span="20">
          <span>编码开始：{{simulateRes.code_start}}</span>
          <span>编码结束：{{simulateRes.code_end}}</span>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogClose" id="back-style">取 消</el-button>
      <el-button type="primary"
                 @click="simulate">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { EncodeRuleApi } from '@/services/EncodeRule'
export default {
  data () {
    return {
      visible: false,
      simulateForm: {
        rule_code_resolve_id: '',
        rule_name: '',
        apply_num: '',
        sources_data_value: ''
      },
      tempForm: {
        rule_code_resolve_id: '',
        rule_name: '',
        apply_num: '',
        sources_data_value: ''
      },
      formRules: {
        apply_num: [
          { required: true, message: '请输入申请数量', trigger: 'blur' }
        ]
      },
      simulateRes: {}
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogForm: {
      type: Object
    }
  },
  watch: {
    dialogVisible (newval) {
      this.visible = newval
    },
    dialogForm (newval) {
      let tempForm = JSON.parse(JSON.stringify(this.tempForm))
      this.simulateForm = Object.assign(tempForm, JSON.parse(JSON.stringify(newval)))
    }
  },
  methods: {
    dialogClose () {
      this.simulateRes = {}
      this.$emit('update:dialogVisible', false)
    },
    simulate () {
      this.$refs.simulateForm.validate((valid) => {
        if (valid) {
          EncodeRuleApi.encodeSimulate({
            data: this.simulateForm
          }).then(res => {
            if (res.code === 0) {
              this.simulateRes = res.data
            }
          }, err => {
            console.log(err)
          })
        }
      })
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
.simulate-dialog-container {
  .simulate-res {
    display: flex;
    justify-content: space-between;
    padding-left: 100px;
  }
  .back-style{
    margin-right:12px
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SettingManage/components/SimulateRuleDialog.vue